(() => {
  if (window.nlFilterControls) return;
  window.nlFilterControls = true;
  const labels = document.currentScript?.dataset || {};
  const selector = '.nlbl select,.nls-selects select,.nlsf-controls select,.facet-filters__sort';
  const instances = new Set();
  let serial = 0;
  let active;
  class FilterControl {
    constructor(select) {
      this.select = select;
      this.label = [...(select.labels || [])].map(label => [...label.childNodes].filter(node => node.nodeType === 3 || (node.nodeType === 1 && !node.contains(select))).map(node => node.textContent).join(' ').trim()).filter(Boolean).join(' ') || select.getAttribute('aria-label') || '';
      this.wrap = document.createElement('div');
      this.wrap.className = 'nl-filter';
      select.before(this.wrap);
      this.wrap.append(select);
      this.button = document.createElement('button');
      this.button.className = 'nl-filter__trigger';
      this.button.type = 'button';
      this.button.setAttribute('role', 'combobox');
      this.button.setAttribute('aria-haspopup', 'listbox');
      this.button.setAttribute('aria-expanded', 'false');
      this.wrap.append(this.button);
      this.panel = document.createElement('div');
      this.panel.className = 'nl-filter-panel';
      this.panel.setAttribute('popover', 'auto');
      this.panel.hidden = true;
      this.search = document.createElement('input');
      this.search.type = 'search';
      this.search.className = 'nl-filter-panel__search';
      this.search.autocomplete = 'off';
      this.search.placeholder = labels.searchLabel || '';
      this.search.setAttribute('aria-label', labels.searchLabel || this.label);
      this.list = document.createElement('div');
      this.list.className = 'nl-filter-panel__list';
      this.list.id = `NLFilterOptions-${++serial}`;
      this.list.setAttribute('role', 'listbox');
      this.list.setAttribute('aria-label', this.label);
      this.button.setAttribute('aria-controls', this.list.id);
      this.empty = document.createElement('p');
      this.empty.className = 'nl-filter-panel__empty';
      this.empty.textContent = labels.emptyLabel || '';
      this.empty.hidden = true;
      this.panel.append(this.search, this.list, this.empty);
      document.body.append(this.panel);
      select.dataset.nlEnhanced = 'true';
      this.button.addEventListener('click', event => { event.preventDefault(); this.open ? this.close() : this.show(); });
      this.button.addEventListener('keydown', event => {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault(); this.show(false); const options = this.options();
          (event.key === 'End' || event.key === 'ArrowUp' ? options.at(-1) : options[0])?.focus();
        }
      });
      this.panel.addEventListener('keydown', event => this.keydown(event));
      this.panel.addEventListener('toggle', event => { if (event.newState === 'closed') this.close(); });
      this.search.addEventListener('input', () => this.render());
      select.addEventListener('change', () => this.refresh());
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(select, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'selected', 'label', 'value', 'hidden'] });
      instances.add(this);
      this.refresh();
    }
    options() { return [...this.list.querySelectorAll('[role="option"]:not(:disabled)')]; }
    refresh() {
      const option = this.select.selectedOptions[0];
      this.button.textContent = !option?.value && this.label ? this.label : option?.textContent || this.label;
      this.button.setAttribute('aria-label', `${this.label}: ${option?.textContent || this.label}`);
      this.button.disabled = this.select.disabled;
      this.wrap.classList.toggle('nl-filter--selected', Boolean(option?.value && this.select.selectedIndex > 0));
      if (this.open) this.render();
    }
    render() {
      const query = this.search.value.trim().toLocaleLowerCase();
      this.list.replaceChildren();
      [...this.select.options].filter(option => !option.hidden && (!query || option.textContent.toLocaleLowerCase().includes(query))).forEach(option => {
        const item = document.createElement('button');
        item.type = 'button'; item.className = 'nl-filter-panel__option'; item.tabIndex = -1;
        item.setAttribute('role', 'option'); item.setAttribute('aria-selected', String(option.selected));
        item.textContent = option.textContent; item.disabled = option.disabled;
        item.addEventListener('click', () => {
          this.select.value = option.value;
          this.select.dispatchEvent(new Event('input', { bubbles: true }));
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
          this.refresh(); this.close(true);
        });
        this.list.append(item);
      });
      this.empty.hidden = this.list.children.length > 0;
    }
    show(focusSearch = true) {
      if (this.button.disabled) return;
      if (active && active !== this) active.close();
      this.open = true; active = this; this.search.value = '';
      this.search.hidden = this.select.options.length < 9;
      this.render(); this.panel.hidden = false; this.button.setAttribute('aria-expanded', 'true');
      const rect = this.button.getBoundingClientRect();
      const width = Math.min(Math.max(rect.width, 260), innerWidth - 32);
      const availableBelow = innerHeight - rect.bottom - 24;
      const below = availableBelow >= 220 || rect.top < 260;
      this.panel.style.width = `${width}px`;
      this.panel.style.left = `${Math.max(16, Math.min(rect.left, innerWidth - width - 16))}px`;
      this.panel.style.top = below ? `${rect.bottom + 8}px` : 'auto';
      this.panel.style.bottom = below ? 'auto' : `${innerHeight - rect.top + 8}px`;
      this.panel.style.maxHeight = `${Math.min(400, Math.max(160, below ? availableBelow : rect.top - 24))}px`;
      this.panel.showPopover?.();
      if (!this.search.hidden && focusSearch) this.search.focus();
      else if (focusSearch) (this.list.querySelector('[aria-selected="true"]') || this.options()[0])?.focus();
    }
    close(restoreFocus = false) {
      if (!this.open) return;
      this.open = false;
      this.panel.hidePopover?.(); this.panel.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
      if (active === this) active = undefined;
      if (restoreFocus && this.button.isConnected) this.button.focus();
    }
    keydown(event) {
      const options = this.options(); const index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); this.close(true); }
      else if (event.key === 'Tab') this.close(true);
      else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : event.key === 'ArrowDown' ? (index + 1) % options.length : (index - 1 + options.length) % options.length;
        options[next]?.focus();
      }
    }
    destroy() { this.close(); this.observer.disconnect(); this.panel.remove(); instances.delete(this); }
  }
  function enhance(root) {
    const selects = root.matches?.(selector) ? [root] : [...root.querySelectorAll?.(selector) || []];
    selects.filter(select => !select.dataset.nlEnhanced).forEach(select => new FilterControl(select));
    instances.forEach(control => { if (!control.select.isConnected) control.destroy(); });
  }
  enhance(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1 && !node.closest('.nl-filter-panel')) enhance(node); }));
    instances.forEach(control => { if (!control.select.isConnected) control.destroy(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('pointerdown', event => { if (active && !active.panel.contains(event.target) && !active.wrap.contains(event.target)) active.close(); });
  document.addEventListener('input', () => queueMicrotask(() => instances.forEach(control => control.refresh())));
  document.addEventListener('change', () => queueMicrotask(() => instances.forEach(control => control.refresh())));
  document.addEventListener('click', event => {
    if (event.target.closest('[data-library-clear],[data-stock-clear],[data-clear],[data-maker-choice],[data-model-choice],[data-type-choice],[data-department]')) queueMicrotask(() => instances.forEach(control => control.refresh()));
  });
  window.addEventListener('popstate', () => queueMicrotask(() => instances.forEach(control => control.refresh())));
  window.addEventListener('resize', () => active?.close());
})();
